// For Sonar Fixing issue : Refactor this function to reduce its Cognitive Complexity to the 15 allowed.
export const AcceptTermsHelperTextUserDetails = () => {
    const getAcceptTermHelperTextUserDetails=(props)=>
    {
        return (
            props.formik.touched.acceptTerms && props.formik.errors.acceptTerms
        );
    }
    return {getAcceptTermHelperTextUserDetails}
}